import { Product } from '../product/Product'
import { Prop } from '@typegoose/typegoose'
import { Field, ID, Float, ObjectType, InputType } from 'type-graphql'
import { RelatedEntity } from '../base/RelatedEntity'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('LogisticItemInput')
export class LogisticItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('lgi') })
  _id: string

  @Field(() => Product)
  @Prop({ type: () => RelatedEntity })
  product: ReturnType<() => Product>

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => Float)
  @Prop({ type: Number })
  inventoryCount: number

  /**
   * The line's amount in dollars, typed directly by the user — there is no unit price and
   * no price-times-quantity for a logistics line. Mongoose cannot enforce the two-decimal
   * rounding, so computeLogisticAmount rounds it on every write; storing it unrounded would
   * let two lines like 100.994 each print as $100.99 while summing into a gross of 201.99,
   * so the printed lines would stop adding up to the printed gross.
   */
  @Field(() => Float)
  @Prop({ type: Number })
  net: number

  //This has field resolver, but we put it here for type-safety too
  @Field(() => Float)
  shippingWeight: number
}
